import get from 'lodash/get';

import { Box, Typography } from '@sbv-clients/ui-shared';

import { useAdminFacilityIdGet } from '../../services/admin';
import FacilityUsersGrid from './facility-users-grid/facility-users-grid';

const useFacilityName = (facilityId: string) => {
  const { data: facilityData } = useAdminFacilityIdGet(facilityId);
  return get(facilityData, 'data.name', '');
};

export const ListFacilityUsersPage = ({
  facilityId,
}: {
  facilityId: string;
}) => {
  const facilityName = useFacilityName(facilityId);
  return (
    <Box
      height="100%"
      display="grid"
      gridTemplateRows="auto 1fr"
      p={2}
      rowGap={2}
    >
      <Typography variant="h4">{facilityName || '-'}</Typography>
      <FacilityUsersGrid facilityId={facilityId} />
    </Box>
  );
};
